var exports = {
  "kL": "xe564cbfb--bd2f8d--container",
  "UJ": "xe564cbfb--bd2f8d--content-container",
  "e": "xe564cbfb--bd2f8d--text-container",
  "Sl": "xe564cbfb--bd2f8d--image",
  "ic": "xe564cbfb--bd2f8d--image--with-image",
};

module.exports = exports;
